import React from 'react';
import { styled } from 'dripsy';
import { observer } from 'mobx-react-lite';
import { View } from 'react-native';

import { BaseText } from '@components';
import { IS_WEB } from '@utils';
import type { Course } from '@models/Courses/CourseModel';
import type { Tutorial } from '@models/Tutorials/TutorialModel';

const Title = styled(BaseText)({
  color: '$heading800',
  variant: IS_WEB ? 'text.xbig' : 'text.xxlarge',
  fontWeight: 'semi',
});

export interface ICourseTitleProps {
  course: Course;
  tutorial: Tutorial;
}

export const CourseTitle = observer<ICourseTitleProps>(
  ({ course, tutorial }) => {
    const lessonName =
      course.lessons.getLessonByTutorialId(tutorial.id)?.name ?? '';

    const title = IS_WEB
      ? `${lessonName}: ${tutorial.title}`
      : tutorial.title;

    return (
      <View>
        <Title>{title}</Title>
      </View>
    );
  },
);
